import anime from "animejs";

export const animeFloatComponent = () => {
    anime({
        targets: '.anime-float',
        translateY: ['0px', '-16px'],
        easing: 'easeInOutSine',
        loop: true,
        direction: 'alternate',
        duration: 800,
    });
};